import './new_container.scss';
import React, { ReactElement } from 'react';

interface Props {
  children: React.ReactNode;
}

export function NewContainer({ children }: Props): ReactElement {
  return <div className={'new-container'}>{children}</div>;
}
